import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import React from "react";
import useSuccessModalStore from "./api/store";
import { ModalTransition } from "../transitions";
import StyledDialogActions from "../dialog/dialog-actions";
import { CheckCircle } from "@mui/icons-material";
import { defaultButtonProps } from "../buttons/sxprops";

export interface ISuccessModal {
  message: string;
  walktroughMode?: boolean;
}
export const SuccessModal: React.FC<ISuccessModal> = ({
  message,
  walktroughMode = false,
}) => {
  const store = useSuccessModalStore();
  return (
    <Dialog
      open={store.isShowModal}
      slots={{
        transition: ModalTransition,
      }}
      hideBackdrop={walktroughMode ? true : false}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "24px",
            margin: "0px",
            padding: "0px",
          },
        },
      }}
      keepMounted
      aria-describedby="alert-dialog-slide-description"
      sx={{
        zIndex: walktroughMode ? (theme) => theme.zIndex.modal - 1 : null,
      }}
    >
      <Box id="success-modal">
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minWidth: "450px",
            mt: "28px",
          }}
        >
          <CheckCircle
            color="success"
            sx={{
              fontSize: "80px",
            }}
          />
          <br />
          <Typography variant="h4" color="success" align="center">
            {message}
          </Typography>
        </DialogContent>

        <StyledDialogActions>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              ref={store.continueButtonRef}
              fullWidth={false}
              sx={{
                ...defaultButtonProps,
                width: "100px",
                color: "white",
              }}
              onClick={() => store.setShowModal(false)}
            >
              Continue
            </Button>
          </Box>
        </StyledDialogActions>
      </Box>
    </Dialog>
  );
};
